import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2, KeyRound } from "lucide-react";
import { api, apiErrorMessage } from "../api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [state, setState] = useState({ status: "idle" });

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) return setState({ status: "error", message: "Password must be at least 6 characters." });
    if (pw !== pw2) return setState({ status: "error", message: "Passwords don't match." });
    setState({ status: "loading" });
    try {
      await api.resetPassword(token, pw);
      setState({ status: "ok" });
    } catch (ex) {
      setState({ status: "error", message: apiErrorMessage(ex, "Reset failed.") });
    }
  };

  if (!token) {
    return (
      <div className="min-h-screen bg-forest text-white flex items-center justify-center px-4">
        <div className="text-center space-y-3">
          <XCircle size={40} className="mx-auto text-coral" />
          <h1 className="font-display text-3xl">Missing reset token</h1>
          <Link to="/signin" className="text-coral underline text-sm">Back to sign in</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-forest text-white flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center space-y-4" data-testid="reset-password-page">
        {state.status === "ok" ? (
          <>
            <CheckCircle2 size={40} className="mx-auto text-emerald-300" />
            <h1 className="font-display text-3xl">Password updated</h1>
            <p className="text-white/70 text-sm">Sign in with your new password.</p>
            <button onClick={() => nav("/signin")} className="btn-coral px-4 py-2 rounded-md text-sm font-medium mt-2">
              Go to sign in
            </button>
          </>
        ) : (
          <form onSubmit={submit} className="space-y-4 text-left bg-white text-forest rounded-xl p-6">
            <div className="flex items-center gap-2">
              <KeyRound size={20} className="text-coral" />
              <h1 className="font-display text-2xl">Reset your password</h1>
            </div>
            <div>
              <label className="text-xs font-semibold">New password</label>
              <input
                type="password" value={pw} onChange={(e) => setPw(e.target.value)}
                data-testid="reset-password-new" autoFocus
                className="mt-1 w-full border border-cream rounded-md px-3 py-2 text-sm text-forest"
              />
            </div>
            <div>
              <label className="text-xs font-semibold">Confirm new password</label>
              <input
                type="password" value={pw2} onChange={(e) => setPw2(e.target.value)}
                data-testid="reset-password-confirm"
                className="mt-1 w-full border border-cream rounded-md px-3 py-2 text-sm text-forest"
              />
            </div>
            {state.status === "error" && (
              <div className="text-xs text-red-600" data-testid="reset-password-error">{state.message}</div>
            )}
            <button
              type="submit"
              disabled={state.status === "loading"}
              data-testid="reset-password-submit"
              className="btn-coral w-full px-4 py-2 rounded-md text-sm font-medium disabled:opacity-40 inline-flex items-center justify-center gap-2"
            >
              {state.status === "loading" ? <Loader2 size={14} className="animate-spin" /> : null}
              Update password
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
